import { render, staticRenderFns } from "./Postagens.vue?vue&type=template&id=6a7662ac&scoped=true"
import script from "./Postagens.vue?vue&type=script&lang=js"
export * from "./Postagens.vue?vue&type=script&lang=js"
import style0 from "./Postagens.vue?vue&type=style&index=0&id=6a7662ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7662ac",
  null
  
)

export default component.exports